import { VENDOR_UPLOAD_STATUS } from 'Data/constants';
export const getStatusMessage = value => {
	let message = '';
	switch (value) {
		case VENDOR_UPLOAD_STATUS.UPLOADING:
			message = 'File uploading is in progress.';
			break;
		case VENDOR_UPLOAD_STATUS.UPLOADFAILED:
			message = 'File uploading failed. Please try uploading again.';
			break;
		case VENDOR_UPLOAD_STATUS.UPLOADED:
			message = 'File is uploaded.';
			break;
		case VENDOR_UPLOAD_STATUS.VALIDTING:
			message = 'File validation is in progress.';
			break;
		case VENDOR_UPLOAD_STATUS.VALIDATIONFAILED:
			message = 'File validation failed. Please try uploading again.';
			break;
		case VENDOR_UPLOAD_STATUS.VALIDATED:
			message = 'File  Validated.';
			break;
		case VENDOR_UPLOAD_STATUS.FILEFORMATERROR:
			message = 'File encoding is incorrect. Please use CSV with UTF-8 format.';
			break;
		case VENDOR_UPLOAD_STATUS.ILLEGALCHARACTERERROR:
			message = 'Illegal characters found in data. Please try uploading again.';
			break;
		case VENDOR_UPLOAD_STATUS.TRANSLATING:
			message = 'Translation is in progress.';
			break;
		case VENDOR_UPLOAD_STATUS.TRANSLATIONFAILED:
			message = 'Data translation failed. Please try uploading again.';
			break;
		case VENDOR_UPLOAD_STATUS.TRANSLATED:
			message = 'Translation is completed.';
			break;
		case VENDOR_UPLOAD_STATUS.PREPROCESSINGFAILED:
			message = 'Data preprocessing failed. Please try uploading again.';
			break;
		case VENDOR_UPLOAD_STATUS.DEDUPPING:
			message = 'Dedup is in progress.';
			break;
		case VENDOR_UPLOAD_STATUS.DEDUPFAILED:
			message = 'Data dedup failed. Please try uploading again.';
			break;
		case VENDOR_UPLOAD_STATUS.DEDUPPED:
			message = 'Dedup is completed.';
			break;
		case VENDOR_UPLOAD_STATUS.FILEGENERATED:
			message = 'File generated successfully.';
			break;
		case VENDOR_UPLOAD_STATUS.FILEGENERATIONFAILED:
			message = 'File generation failed.';
			break;
		case VENDOR_UPLOAD_STATUS.PUBLISHING:
			message = 'File publishing is in progress.';
			break;
		case VENDOR_UPLOAD_STATUS.PUBLISHFAILED:
			message = 'File publishing failed.';
			break;
		case VENDOR_UPLOAD_STATUS.PUBLISHED:
			message = 'File published successfully.';
			break;
		default:
			message = 'Normalization Failed';
	}
	return message;
};
